import { useSnackbar } from 'notistack';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Box, Stack, Container } from '@mui/material';

import { paths } from 'src/routes/routes/paths';

import { useResponsive } from 'src/hooks/use-responsive';

import { MetaHelmet } from 'src/layouts/Helmet/Helmet';
import { getAdvertiserProfile } from 'src/server/store/auth';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import AutomationUpdate from 'src/sections/automation/curd/automationUpdate';

function UpdateAutomationPage() {
  const settings = useSettingsContext();
  const isMobile = useResponsive('down', 'sm');

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const credentialsYear = {
      enqueueSnackbar,
    };
    dispatch(getAdvertiserProfile(credentialsYear));
  }, [dispatch, enqueueSnackbar]);

  return (
    <>
      <MetaHelmet title="Update Automation" />
      <Container maxWidth={settings.themeStretch ? false : 'xl'}>
        <Box
          display={isMobile ? '' : 'flex'}
          alignItems="center"
          justifyContent={isMobile ? '' : 'space-between'}
          width="100%"
        >
          <Stack>
            <CustomBreadcrumbs
              heading="Update Automation"
              links={[
                {
                  name: 'Dashboard',
                  href: paths.dashboard.root,
                },
                {
                  name: 'Automation',
                  href: paths.dashboard.automation,
                },
                {
                  name: 'Update Automation ',
                },
              ]}
              sx={{
                mb: { xs: 3, md: 5 },
              }}
            />
          </Stack>
        </Box>
        <AutomationUpdate />
      </Container>
    </>
  );
}

export default UpdateAutomationPage;
